import Cookies from 'universal-cookie';

import { decodeToken, fetchToken, getAuthCode, returnHostUrl } from '../../util/axiosHelper';
import { fetchCustomerAccounts } from './accountActions';

import { FETCH_TOKEN, FETCH_TOKEN_START, FETCH_TOKEN_END, FETCH_TOKEN_ERROR } from './types';
import { piService, messages } from '../../util/constants';
import { initReceiver, inIframe } from '../../util/iframeHelpers';

const cookie = new Cookies();

export const fetchAgentToken = authCode => async dispatch => {
  dispatch({
    type: FETCH_TOKEN_START,
  });

  try {
    let access = {};
    const res = await fetchToken(authCode);
    const { access_token, id_token } = res.data;
    const in1hr = new Date(new Date().getTime() + 60 * 60 * 1000);

    if (access_token) {
      sessionStorage.setItem(piService.accessToken, access_token);
      cookie.set(piService.accessToken, access_token, {
        path: '/',
        expires: in1hr,
      });
    }

    if (id_token) {
      sessionStorage.setItem(piService.agentToken, id_token.toString());
      cookie.set(piService.agentToken, id_token.toString(), {
        path: '/',
        expires: in1hr,
      });

      access = decodeToken(id_token);
    }

    dispatch({
      type: FETCH_TOKEN,
      payload: access,
    });
  } catch (e) {
    if (e.response) {
      const { message } = e.response.data;
      dispatch({
        type: FETCH_TOKEN_ERROR,
        payload: message,
      });
    } else {
      dispatch({
        type: FETCH_TOKEN_ERROR,
        payload: e.message,
      });
    }
  }

  dispatch({
    type: FETCH_TOKEN_END,
  });
};

export const checkURLStatus = () => async dispatch => {
  let searchCriteria;
  const { authCode, accountNumber, divisionBillingId, systemError } = getAuthCode();

  if (inIframe()) {
    initReceiver();
    return;
  }

  if (sessionStorage.getItem(piService.agentToken)) {
    const id_token = sessionStorage.getItem(piService.agentToken);
    const access = decodeToken(id_token);

    dispatch({
      type: FETCH_TOKEN,
      payload: access,
    });

    if (accountNumber) {
      searchCriteria = { AccountNumber: accountNumber };

      if (divisionBillingId) {
        searchCriteria = { ...searchCriteria, divisionBillingId };
      }

      await dispatch(fetchCustomerAccounts(searchCriteria));
    }
  } else {
    if (!authCode && !systemError) {
      const encodedState = accountNumber ? `&state=${btoa(`ACCTNUM=${accountNumber}`)}` : '';
      if (returnHostUrl().isResi) {
        const replaceURL = encodedState ? `${returnHostUrl().loginUrl}${encodedState}` : returnHostUrl().loginUrl;
        window.location.replace(replaceURL);
      } else {
        const replaceURL = encodedState ? `${returnHostUrl().smbLoginUrl}${encodedState}` : returnHostUrl().smbLoginUrl;
        window.location.replace(replaceURL);
      }
    }

    if (!authCode && systemError) {
      if (systemError === piService.authError) {
        dispatch({
          type: FETCH_TOKEN_ERROR,
          payload: messages.noAccessMessage,
        });
      } else {
        dispatch({
          type: FETCH_TOKEN_ERROR,
          payload: messages.systemErrorMessage,
        });
      }
    }

    if (authCode && !systemError) {
      await dispatch(fetchAgentToken(authCode));

      if (accountNumber) {
        searchCriteria = { AccountNumber: accountNumber };

        if (divisionBillingId) {
          searchCriteria = { ...searchCriteria, divisionBillingId };
        }

        await dispatch(fetchCustomerAccounts(searchCriteria));
      }
    }
  }
};
